import React from 'react';

interface FinalCTAProps {
    onOpenModal: () => void;
}

export const FinalCTA: React.FC<FinalCTAProps> = ({ onOpenModal }) => {

    return (
        <section className="py-24 bg-gradient-to-b from-purple-900/20 to-black">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
                    🌙 Let NyxBot work the night shift
                </h2>
                <p className="text-xl text-gray-300 mb-8">
                    Be the first to flash stake without lifting a finger.
                </p>
                <button
                    onClick={onOpenModal}
                    className="px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg text-white font-bold text-lg hover:from-purple-600 hover:to-pink-600 transition-all transform hover:scale-105 shadow-lg hover:shadow-purple-500/25 mb-4"
                >
                    Join Waitlist - 0.1 SOL
                </button>
                <div className="flex items-center justify-center space-x-2 text-orange-400">
                    <span>⚠️</span>
                    <span>Limited spots remaining</span>
                </div>
            </div>
        </section>
    );
};